import React, { useEffect, useState, useContext, useRef } from "react";
import {
  Container,
  Grid,
  makeStyles,
  Typography,
  CssBaseline,
  Button,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import { validarRUT } from "validar-rut";
import MaskedInput from "react-text-mask";
import { TextField, Loader, PopUp } from "../components";
import { FormValidator, onBlur } from "../helpers";
import { AuthContext } from "../context";
import { InfoCircleIcon, ShowIcon } from "../icons";
import { doctorServices } from "../services";
import { modals } from "../constants";

// [CAPTCHA] import ReCAPTCHA from "react-google-recaptcha";

export default function Login(props) {
  const classes = useStyles(props)();

  const [rut, setRut] = useState("");
  const [password, setPassword] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [modal, setModal] = useState(false);
  const [modalName, setModalName] = useState(modals[7]);
  const [modalMessage, setModalMessage] = useState("");
  const [modalError, setModalError] = useState(false);
  const [modalStep, setModalStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const { signIn } = useContext(AuthContext);

  // [CAPTCHA]
  // const [isCaptchaVisible, setIsCaptchaVisible] = useState(false);
  // const [disableLoginButton, setDisableLoginButton] = useState(false);
  const [showResendVerification, setShowResendVerification] = useState(false);

  // [CAPTCHA] const captchaRef = useRef(null);

  // [CAPTCHA]
  // const captchaOnChange = () => {
  //   if (captchaRef.current.getValue()) {
  //     console.log("User is not a robot!");
  //     setDisableLoginButton(false);
  //   }
  // };

  const validator = new FormValidator([
    /*{
            field: 'email',
            method: 'isEmpty',
            validWhen: false,
            message: 'Ingrese correo electronico.'
        },*/
    {
      field: "rut",
      method: "isEmpty",
      validWhen: false,
      message: "Ingrese su Rut.",
    },
    {
      field: "rut",
      method: (rut) => validarRUT(rut),
      validWhen: true,
      message: "Rut invalido.",
    },
    {
      field: "password",
      method: "isEmpty",
      validWhen: false,
      message: "Ingrese contraseña.",
    },
  ]);

  useEffect(() => {
    function init() {
      const rut = localStorage.getItem("userRut");
      if (rut) {
        setRut(`${rut.slice(0, rut.length - 1)}-${rut.slice(rut.length - 1)}`);
      }
    }
    init();
  }, []);
  //const location = useLocation();
  //const history = useHistory();

  const onSubmit = async () => {
    const validation = validator.validate({
      rut,
      password,
    });
    setErrors(validation);
    if (validation.isValid) {
      try {
        setLoading(true);
        const { status, response } = await doctorServices.loginUserDoctor({
          rut: `${rut.split("-")[0]}${rut.split("-")[1]}`,
          password,
        });
        setLoading(false);
        if (status === 200) {
          if (response.error) {
            setModalName(modals[2]);
            setModalError(true);

            if (response.error.code === 403 && response.error.message?.toLowerCase().includes('verific')) {
              setModalMessage("Su correo electrónico aún no ha sido verificado. Revise su bandeja de entrada — le enviamos un enlace al registrarse. Si no lo encontró, puede solicitar el reenvío.");
              setShowResendVerification(true);
              // [CAPTCHA] captchaRef.current?.reset();
              // [CAPTCHA] setIsCaptchaVisible(true);
              // [CAPTCHA] setDisableLoginButton(true);
            } else {
              setModalMessage(response.error.message);
              // [CAPTCHA] captchaRef.current?.reset();
              // [CAPTCHA] setIsCaptchaVisible(true);
              // [CAPTCHA] setDisableLoginButton(true);
            }

            setModal(true);
          } else {
            //alert(response.message)
            
            // Extract tokens based on guide:
            // The response might be { user: { accessToken, refreshToken, ... } }
            // or { user: ..., token: ... } depending on backend.
            // But guide says: "Los tokens están ANIDADOS dentro del objeto 'user'"
            // const { accessToken, refreshToken } = response.user;
            
            const userObj = response.user || response.data?.user || response;
            const accessToken = userObj.accessToken || userObj.token;
            
            signIn({
              token: accessToken, // Access token
              user: response.user, // User object (hopefully containing refreshToken too, or we merge it)
              doctor: response.doctor,
            });
          }
        } else if (status === 400 || status === 403 || status === 401) {
          if (response.error) {
            setModalName(modals[2]);
            setModalError(true);
            
            // Handle unverified user error specifically based on backend message
            const errorMessage = response.error.message || response.error;
            if (typeof errorMessage === 'string' && (errorMessage.toLowerCase().includes('verific') || errorMessage.toLowerCase().includes('valid'))) {
                setModalMessage("Para ingresar debe verificar su correo electrónico. Revise su bandeja de entrada.");
            } else {
                setModalMessage(errorMessage);
            }
            
            setModal(true);
          }
        }
      } catch (e) {
        setLoading(false);
        console.log("Error", e);
      }
    }
  };

  const onResendVerification = async () => {
    try {
      setLoading(true);
      const rutClean = `${rut.split("-")[0]}${rut.split("-")[1]}`;
      const { status, response } = await doctorServices.resendVerificationEmail({ username: rutClean });
      setLoading(false);
      setModalError(false);
      setModalName(modals[2]);
      if (status === 200) {
        setShowResendVerification(false);
        setModalMessage("Correo de verificación reenviado. Revise su bandeja de entrada.");
      } else {
        setModalMessage(response?.error || "Error al reenviar el correo. Intente nuevamente.");
      }
      setModal(true);
    } catch {
      setLoading(false);
    }
  };

  const onClickChangePassword = async ({ rut: rutNormalized, token, password }) => {
    setModal(false);
    if (!modalStep) {
      try {
        setLoading(true);
        const { status } =
          await doctorServices.sendTokenResetPassword({
            rut: rutNormalized,
          });
        setLoading(false);
        if (status === 200) {
          setModalStep(1);
        } else {
          setModalError(true);
          setModalMessage(
            "No pudimos enviar las instrucciones. Intenta nuevamente más tarde o verifica el RUT."
          );
          setModalName(modals[2]);
          setModal(true);
        }
      } catch (e) {
        setLoading(false);
        setModalError(true);
        setModalMessage(
          "No pudimos enviar las instrucciones. Intenta nuevamente más tarde o verifica el RUT."
        );
        setModalName(modals[2]);
        setModal(true);
        console.log(e);
      }
      setModal(true);
    } else {
      try {
        setLoading(true);
        const { status, response } = await doctorServices.updatePassword({
          token,
          password,
        });
        setLoading(false);
        if (status === 200) {
          if (response.error) {
            setModalError(true);
            setModalMessage(response.error.message);
          } else {
            setModalError(false);
            setModalMessage(response.message);
          }
          setModalName(modals[2]);
          setModal(true);
        }
      } catch (e) {
        setLoading(false);
        console.log(e);
      }
      setModalStep(0);
    }
  };

  const onKeyDownHandler = (e) => {
    if (e.keyCode === 13) {
      onSubmit();
    }
  };

  const onChangeRut = async (e) => {
    setRut(e.target.value);
    if (e.target.value.length >= 8) {
      setErrors(
        await onBlur({ field: "rut", value: e.target.value, validator, errors })
      );
    }
  };

  const terminosYcondciones = () => {
    window.open("/doc/Terminos_y_condiciones_unio.pdf", "_blank");
  };

  const politicasYPrivacidad = () => {
    window.open("/doc/Politica_de_privacidad_unio.pdf", "_blank");
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const passwordRecovery = params.get("passwordRecovery");

    if (passwordRecovery === "true") {
      setModal(prevModal => !prevModal);
    }
  }, []);

  return (
    <Grid container alignItems="flex-end">
      {loading && <Loader loading={true} />}
      <PopUp
        modalName={modalName}
        open={modal}
        setModal={() => {
          setModal(!modal);
          setModalName(modals[7]);
        }}
        modalStep={modalStep}
        message={modalMessage}
        modalError={modalError}
        hideErrorWord
        setModalStep={(value) => setModalStep(value)}
        modalSubMessage={"Contraseña actualizada con éxito."}
        onClickChangePassword={({ rut, token, password }) =>
          onClickChangePassword({ rut, token, password })
        }
      />
      <Container className={classes.container} component="main" maxWidth="md">
        <CssBaseline />
        <Grid
          container
          style={{ padding: "45px 0 52px" }}
          justify="center"
          alignItems="center"
        >
          <img src="../../assets/logo/logo-unio.png" alt="" />
        </Grid>
        <Grid
          container
          direction="column"
          alignItems="center"
          justify="center"
          className={classes.paper}
        >
          <Grid container spacing={3} className={classes.form} justify="center">
            <Grid item md={12} xs={12}>
              <Typography component="h1" variant="h1" align="center">
                Inicio de sesión
              </Typography>
            </Grid>
            <Grid item md={6} xs={12}>
              <TextField
                name={"rut"}
                placeholder="Rut *"
                value={rut}
                onChange={onChangeRut}
                onKeyPress={() => {}}
                onBlur={async () =>
                  setErrors(
                    await onBlur({
                      field: "rut",
                      value: rut,
                      validator,
                      errors,
                    })
                  )
                }
                error={errors.rut && errors.rut.isInvalid}
                helperText={errors.rut ? errors.rut.message : ""}
                inputComponent={TextMaskCustom}
              />
            </Grid>
            {/*<Grid item md={6} xs={12}>
                            <TextField 
                                name={"email"}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Nombre de usuario"
                                value={email}
                                onBlur={async () => setErrors(await onBlur({field:'email', value:email, validator, errors}))}
                                error={errors.email && errors.email.isInvalid}
                                helperText={errors.email? errors.email.message:''}
                            />
                        </Grid>*/}
            <Grid item md={6} xs={12}>
              <TextField
                type={showPassword ? "text" : "password"}
                name={"password"}
                placeholder="Contraseña"
                style={{ justifyContent: "flex-end" }}
                iconComponent={() => <ShowIcon />}
                onKeyPress={(e) => onKeyDownHandler(e)}
                onClickIcon={() => setShowPassword(!showPassword)}
                onChange={(e) => setPassword(e.target.value)}
                onBlur={async () =>
                  setErrors(
                    await onBlur({
                      field: "password",
                      value: password,
                      validator,
                      errors,
                    })
                  )
                }
                error={errors.password && errors.password.isInvalid}
                helperText={errors.password ? errors.password.message : ""}
              />
              <Typography
                onClick={() => setModal(!modal)}
                className={classes.colorText}
                color="secondary"
              >
                <InfoCircleIcon style={{ margin: "0 5px 0 0" }} /> Recuperar
                contraseña
              </Typography>
            </Grid>

            {/* [CAPTCHA]
            {isCaptchaVisible && (
              <Grid item md={8} xs={12} container justify="center">
                <ReCAPTCHA
                  ref={captchaRef}
                  sitekey="6Lcz_FkrAAAAAO9wXBX9Ft6ls16EaYzC6hKhwCBr"
                  onChange={captchaOnChange}
                />
              </Grid>
            )}
            */}

            <Grid item md={8} xs={12} container justify="center">
              <Button
                className={classes.button}
                onClick={onSubmit}
                disabled={false} /* [CAPTCHA] disabled={disableLoginButton} */
              >
                Iniciar sesión
              </Button>
            </Grid>
            {showResendVerification && (
              <Grid item md={8} xs={12} container justify="center">
                <Button
                  variant="outlined"
                  color="primary"
                  fullWidth
                  onClick={onResendVerification}
                  disabled={loading}
                  style={{ marginTop: 8 }}
                >
                  Reenviar correo de verificación
                </Button>
              </Grid>
            )}
            <Grid item md={12} xs={12}>
              <Typography
                className={classes.lineDecoration}
                component="h1"
                variant="h1"
                align="center"
              >
                ¿Aún no tienes cuenta?
              </Typography>
            </Grid>
            <Grid item md={8} xs={12} container justify="center">
              <Link
                to="/registro"
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  textDecoration: "none",
                }}
              >
                <Button
                  className={`${classes.button} ${classes.register}`}
                  onClick={() => {}}
                >
                  Regístrate
                </Button>
              </Link>
            </Grid>
            <Grid item sm={12} xs={12} className={classes.tyc}>
              <Typography align="center">
                Al iniciar o registrarse esta aceptando los <br />{" "}
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a href="#" onClick={(e) => { e.preventDefault(); terminosYcondciones(); }}>
                  {" "}
                  Términos y condiciones{" "}
                </a>
                y nuestras{" "}
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a href="#" onClick={(e) => { e.preventDefault(); politicasYPrivacidad(); }}>
                  {" "}
                  Politícas de privacidad.
                </a>
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Grid>
  );
}

function TextMaskCustom(props) {
  const { inputRef, ...other } = props;
  const { value } = other;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={
        value.length <= 8
          ? [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, "-", /[kK0-9]/, /[kK0-9]/]
          : value.length <= 9
          ? [
              /\d/,
              /\d/,
              /\d/,
              /\d/,
              /\d/,
              /\d/,
              /\d/,
              "-",
              /[kK0-9]/,
              /[kK0-9]/,
            ]
          : [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, "-", /[kK0-9]+/g]
      }
      placeholderChar={"\u2000"}
      placeholder="Rut *"
      guide={false}
      showMask
    />
  );
}

const useStyles = (props) =>
  makeStyles((theme) => ({
    container: {
      overflowY: "scroll",
      height: "calc(100vh - env(safe-area-inset-bottom, 0px))",
      '@supports (height: 100dvh)': {
        height: '100dvh',
      },
      paddingBottom: 'env(safe-area-inset-bottom, 20px)',
      [theme.breakpoints.up("md")]: {
        overflowY: "unset",
      },
      [theme.breakpoints.down("xs")]: {
        padding: 0,
      },
    },
    form: {
      width: "100%", // Fix IE 11 issue.
      margin: 0,
      [theme.breakpoints.up("md")]: {
        /*'& > div:nth-child(1)':{
                margin:"0 0 24px 0",
            }*/
        "& > div:nth-child(1)": {
          "& h1": {
            fontSize: "1.125rem",
            lineHeight: "1.375rem",
          },
        },
      },
    },
    paper: {
      boxSizing: "border-box",
      borderRadius: "45px 45px 0 0",
      boxShadow: "0px -3px 5px #D6D6D6BF",
      [theme.breakpoints.down("xs")]: {
        padding: 25,
      },
      [theme.breakpoints.up("md")]: {
        boxShadow: "unset",
      },
    },
    colorText: {
      fontWeight: "500",
      fontSize: "0.75rem",
      lineHeight: "0.914rem",
      letterSpacing: "0.05em",
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      cursor: "pointer",
      margin: "20px 0 0 0",
    },
    button: {
      backgroundColor: theme.palette.secondary.main,
      fontSize: "1.313rem",
      lineHeight: "1.508rem",
      letterSpacing: " 0.05em",
      color: "#FFFFFF",
      borderRadius: 30,
      fontWeight: "700",
      width: "80%",
      height: 40,
      [theme.breakpoints.up("md")]: {
        fontSize: "1.125rem",
        lineHeight: "1.375rem",
      },
      "&:hover": {
        backgroundColor: theme.palette.secondary.main,
      },
      [theme.breakpoints.down("xs")]: {
        height: 41,
        fontSize: "1.125rem",
        lineHeight: "1.371rem",
      },
    },
    register: {
      backgroundColor: theme.palette.primary.main,
      [theme.breakpoints.up("md")]: {
        "&:hover": {
          backgroundColor: theme.palette.primary.main,
        },
      },
    },
    lineDecoration: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      position: "relative",
      width: "100%",
      [theme.breakpoints.up("md")]: {
        fontSize: "1.125rem",
        lineHeight: "1.375rem",
      },
      "&:before": {
        width: 40,
        border: "2pt solid #C4C4C4",
        content: "' '",
        position: "absolute",
        left: -10,
        borderLeft: 0,
        borderRight: 0,
        borderTop: 0,
        [theme.breakpoints.up("md")]: {
          left: "20%",
          width: 50,
        },
      },
      "&:after": {
        width: 40,
        border: "2pt solid #C4C4C4",
        content: "' '",
        position: "absolute",
        right: -10,
        borderLeft: 0,
        borderRight: 0,
        borderTop: 0,
        [theme.breakpoints.up("md")]: {
          right: "20%",
          width: 50,
        },
      },
    },
    tyc: {
      [theme.breakpoints.up("md")]: {
        position: "relative",
        // bottom: 0,
      },
      [theme.breakpoints.down("md")]: {
        marginBottom: "4rem",
      },
      "& > p": {
        color: theme.palette.primary.main,
        textAlign: "center",
        letterSpacing: 0,
        fontWeight: "bold",
        margin: "48px 0 0",
        [theme.breakpoints.down("xs")]: {
          fontSize: "0.875rem",
        },
        "& a": {
          color: theme.palette.secondary.main,
          textDecoration: "none",
        },
      },
    },
  }));
